module.exports = "<fieldset ng-disabled=form.readonly class=\"schema-form-fieldset {{form.htmlClass}}\" ng-init=\"hide = true\"> <legend ng-class=\"{'sr-only': !showTitle() }\" ng-click=\"hide = !hide\"> <i class=fa ng-class=\"{'fa-caret-right': hide, 'fa-caret-down': !hide}\"></i> {{ form.title }} </legend> <div class=help-block ng-show=form.description ng-bind-html=form.description></div> <div class=fade-in ng-show=!hide sf-field-transclude></div> </fieldset> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./src/main/webapp-files/modules/patients/components/reccordDecorator/fieldset.html
// module id = 297
// module chunks = 0